import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppStore } from '../store/appStore';
import { Trash2 } from 'lucide-react';

export default function Terminal() {
  const { t } = useTranslation();
  const { terminalOutput, clearTerminal } = useAppStore();
  const terminalRef = useRef(null);

  useEffect(() => {
    if (terminalRef.current) {
      terminalRef.current.scrollTop = terminalRef.current.scrollHeight;
    }
  }, [terminalOutput]);

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold text-maroon">{t('terminal.title')}</h3>
        <button
          onClick={clearTerminal}
          className="flex items-center gap-2 px-3 py-1 bg-maroon/20 hover:bg-maroon/30 rounded text-sm transition text-maroon font-semibold"
        >
          <Trash2 size={16} />
          {t('terminal.clear')}
        </button>
      </div>

      <div
        ref={terminalRef}
        className="terminal bg-dark border-2 border-primary rounded-lg p-4 space-y-2 text-sm"
      >
        {terminalOutput.length === 0 ? (
          <div className="text-primary/50">
            <span className="terminal-prompt">$</span> {t('terminal.executing')}...
          </div>
        ) : (
          terminalOutput.map((line, idx) => (
            <div key={idx} className={`terminal-line ${line.type || ''}`}>
              {line.type === 'command' && (
                <>
                  <span className="terminal-prompt">$</span>
                  <span className="terminal-command ml-2">{line.content}</span>
                </>
              )}
              {line.type === 'output' && (
                <span className="terminal-output">{line.content}</span>
              )}
              {line.type === 'success' && (
                <span className="terminal-success">✓ {line.content}</span>
              )}
              {line.type === 'error' && (
                <span className="terminal-error">✗ {line.content}</span>
              )}
              {!line.type && (
                <span className="text-primary/70">{line.content}</span>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
}
